// Hand-authored 52-week engineering velocity pattern. Values 0-4 map to the
// sage ramp tokens (see app/app.css :root): 0 = empty, 1 = sage-l1, …, 4 = sage-l4.
//
// Annotation columns 7, 20, 32, 46 are L4 anchors — leader lines drop straight
// to those engineering peaks. Privacy-velocity reviews are *deliberately
// offset* from the launches (see PRIVACY_FILLED_INDICES) to signal that
// privacy operates on its own quarterly cadence and misses the major events.
//
// Frozen at module scope so SSR and CSR render byte-identical markup; React 19
// hydration cannot mismatch on a constant.
export const INTENSITY: readonly number[] = Object.freeze([
  2, 1, 3, 2, 1, 2, 3, 4, 3, 2, // 0-9    (anchor col 7 → L4)
  1, 2, 1, 2, 3, 1, 2, 1, 2, 3, // 10-19
  4, 3, 2, 1, 2, 3, 1, 2, 3, 1, // 20-29  (anchor col 20 → L4)
  2, 3, 4, 3, 2, 1, 2, 1, 2, 3, // 30-39  (anchor col 32 → L4)
  1, 2, 3, 1, 2, 3, 4, 3, 2, 1, // 40-49  (anchor col 46 → L4)
  2, 1, // 50-51
]);

// Privacy-velocity row: 4 quarter-end reviews. Each lands ~5 weeks AFTER the
// corresponding engineering launch (cols 7→12, 20→25, 32→38, 46→51) — the
// gap is the point. Privacy notices things weeks late.
export const PRIVACY_FILLED_INDICES: readonly number[] = Object.freeze([
  12, 25, 38, 51,
]);
